import { css } from 'styled-components'

export default css`
  background-color: #404040;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0;
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857;
  margin-bottom: 20px;
  padding: 6px 12px;
  text-align: center;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  &:hover {
    background-color: #404040;
  }
`
